import { consumer, IResponse, API, IAssessment } from "@bemap/utils";

const ENDPOINT = '/assessments'

export const getAssessments = async (): Promise<IResponse> => {
  return consumer('GET', ENDPOINT);
}

export const getAssessmentById = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, id);
}

export const getAssessmentByHash = async (hash: string): Promise<IResponse> => {
  return consumer('GET', `${ENDPOINT}/${hash}/hash`);
}

export const resendAssessmentMail = async (id: number): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${id}/resend-email`);
}

export const generateAssessmentReport = async (hash: string): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${hash}/generate-report`);
}

export const downloadAssessmentReport = async (hash: string): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${hash}/download-report`);
}

export const convertReport = async (hash: string): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${hash}/convert-report`);
}

export const mailReport = async (hash: string): Promise<IResponse> => {
  return consumer('GET', ENDPOINT, undefined, `${hash}/send-email`);
}

export const newAssessment = async (payload: IAssessment): Promise<IResponse> => {
  return consumer('POST', ENDPOINT, payload);
}

export const updateAssessment = async (payload: IAssessment): Promise<IResponse> => {
  return consumer('PATCH', ENDPOINT, payload, payload.id);
}

export const deleteAssessment = async (id: number): Promise<IResponse> => {
  return consumer('DELETE', ENDPOINT, undefined, id);
}

export const batchDownload = async (keys: string[]): Promise<Blob> => {
  const url = `${ENDPOINT}/batch-download`
  try {
    const response = await API.post(url, { keys }, {
      responseType: 'blob', // Specify that we expect a blob response
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' }
    });

    return response.data; // Return the blob data
  } catch (error: any) {
    const msg = error.response.data.message;
    throw {
      statusCode: error.response.status,
      message: msg
    };
  }
}

export const getGroupAnalysis = async (assessmentIds: number[]): Promise<IResponse> => {
  return consumer('POST', `${ENDPOINT}/group-analysis`, { assessmentIds });
}